import './profileSteps.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import validator from 'validator';
import className from 'classnames';
import { FormattedText, formatText, getLanguage } from 'core/i18n';
import { actions as formActions } from 'react-redux-form';
import { InputText } from 'components/inputText/inputText';
import { SelectList } from 'components/SelectList/SelectList';
import { RadioButton } from 'components/RadioButton/RadioButton';
import GeoAddress from 'components/GeoAddress';
import GeoSelect from 'components/GeoAddress/GeoFields/GeoSelect';
import GeoInput from 'components/GeoAddress/GeoFields/GeoInput';
import GeoRowGroup from 'components/GeoAddress/GeoRowGroup';
import AlertWarning from 'components/modalOtpUniversia/components/components/alertWarning';
import tools from 'utilities/tools';
import {
    getMaxLenghtPostalCode,
    mustShowExtraAddressFields,
    getLengthAddressNumber,
    getLengthAdditionalInfo,
    getLengthNameOfRoad,
    getPostalCodeMaskCountry,
    normalizeStringsSpain,
    alphabetRegExpByCountry,
} from 'utilities/logicByCountry';
import { disableNationalityByCountry, isCountrySpain } from 'utilities/multiLanguageHelper';
import {
    postalCode,
    noOrdinaryCharactersRegExp,
    validateCellPhone,
    noOrdinaryCharactersRegExpWithDotAndComma,
} from 'commonsUtilities/validations';
import { COUNTRY_CODE_NL, COUNTRY_CODE_ES, COUNTRY_CODE_UA } from 'commonsConstants/countryCodes';
import { updatePhoneFormatByCountry } from 'commonsUtilities/phoneNumberUtils';
import { STREET_LETTER, MAPS_SEARCH } from 'constants/featureFlagging';
import { COUNTRY_PREFIX_UA } from 'constants/multiLanguage';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import { recordEvent } from 'utilities/uTagging';
import { getRoadDataByTypeOfRoad } from './utils';
import { AdditionalDataAdvise } from './additionalDataAdvise/additionalDataAdvise';
import { debounce } from 'utilities/helperFunctions';

class ProfileStep1Form extends React.Component {
    constructor(props) {
        super(props);
        this.handlePhoneOnFocus = this.handlePhoneOnFocus.bind(this);
        this.isFilledAddress = this.isFilledAddress.bind(this);
        this.handleErrorTags = debounce(this.handleErrorTags.bind(this), 300);
        this.extraDataRef = React.createRef();
        this.addressRef = React.createRef();
        this.nameOfRoadRef = React.createRef();
        this.state = {
            warningAdditionalInfo: false,
        };
    }

    handlePhoneOnFocus(inputPhone) {
        const newInputPhoneValue = document.getElementById(inputPhone).value.replace(/\s/g, '');

        return (document.getElementById(inputPhone).value = newInputPhoneValue);
    }

    isFilledAddress() {
        const { userProfile } = this.props;
        const filled = !!userProfile.addressFilled;

        return filled;
    }

    handlePhoneOnBlur = value => {
        return value ? updatePhoneFormatByCountry(value, __ORIGIN_COUNTRY__) : value;
    };

    handleErrorTags = (value, errorKey) => {
        recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            categoriaEvento: 'eventos onboarding',
            accionEvento: 'errores en formularios',
            etiquetaEvento: `${value}:error key ${errorKey}`,
        });
    };

    getLabelAddress = flags => {
        return flags.get(MAPS_SEARCH) ? formatText('field-address') : '';
    };

    getRowTypeOfRoad(handleAddressUpdate, disabled) {
        if (mustShowExtraAddressFields()) {
            return (
                <GeoRowGroup>
                    <GeoSelect
                        id="typeOfRoad"
                        baseModelProperty="typeOfRoad"
                        baseModelForm={this.props.baseModelForm}
                        gmapsType="type_of_road"
                        options={this.props.options.get('typesOfRoads').toJS()}
                        value={this.props.userProfile.typeOfRoad ? this.props.userProfile.typeOfRoad : ''}
                        label={formatText('field-typeOfRoad')}
                        size={4}
                        validators={{
                            required: value => !tools.isEmptyOrWhitespace(value),
                        }}
                        errorMessages={{
                            required: formatText('validation-fieldRequired'),
                        }}
                        onUpdate={handleAddressUpdate}
                        disabled={disabled}
                    />
                    {this.showNameOfRoadInput(disabled)}
                </GeoRowGroup>
            );
        }

        return <GeoRowGroup>{this.showNameOfRoadInput(disabled)}</GeoRowGroup>;
    }

    showNameOfRoadInput = disabled => {
        const { handleAddressUpdate, userProfile } = this.props;

        return (
            <GeoInput
                refProp={this.nameOfRoadRef}
                id="nameOfRoad"
                baseModelProperty="nameOfRoad"
                baseModelForm={this.props.userProfileForm}
                gmapsType="route"
                value={userProfile.nameOfRoad}
                label={formatText('field-nameOfRoad')}
                maxLength={getLengthNameOfRoad()}
                placeholder={formatText('field-nameOfRoad')}
                validators={{
                    required: value => {
                        const isOk = !tools.isEmptyOrWhitespace(value);

                        if (!isOk) {
                            this.handleErrorTags('streetname', 'validation-fieldRequired');
                        }

                        return isOk;
                    },
                    valid: value => {
                        //FIXME: /^[A-Za-z0-9À-ÿ'_./\\?:;-\s\u00C7\u00E7\u005B\u005D\u003C\u003E\u00B4]+$/i
                        const isOk =
                            !tools.isEmptyOrWhitespace(value) &&
                            validator.matches(value.toString(), noOrdinaryCharactersRegExp) &&
                            value.length <= 45;

                        if (!isOk) {
                            this.handleErrorTags('streetname', 'validation-syntaxError');
                        }

                        return isOk;
                    },
                }}
                errorMessages={{
                    required: formatText('validation-fieldRequired'),
                    valid: formatText('validation-syntaxError'),
                }}
                onUpdate={handleAddressUpdate}
                disabled={disabled}
            />
        );
    };

    showBirthCountryInput = () => {
        const {
            userProfile: { birthProvince, birthCountry },
            formActions: { resetValidity, reset },
            handleSave,
        } = this.props;

        return (
            <div className="md-form-group row">
                <div className="col-sm-6">
                    <SelectList
                        profileModel="userProfile.birthCountry"
                        name="birthCountry"
                        optionsList={this.props.birthCountries}
                        clearable={false}
                        label={formatText('field-birthCountry')}
                        placeholder={formatText('field-birthCountry')}
                        validations={{
                            required: value => {
                                if (!birthProvince) resetValidity('userProfile.birthProvince');

                                return value && value.length;
                            },
                        }}
                        autoCompleteField={false}
                        messagesError={{ required: formatText('validation-birthCountryRequired') }}
                        required
                        searchable={true}
                        disabled={false}
                        isUpdated={function () {
                            reset('userProfile.birthProvince');
                            handleSave(null, { birthCountry, birthProvince: '' });
                        }}
                        {...this.props}
                    />
                </div>
            </div>
        );
    };

    showNationalityInput = () => {
        const { userProfile, handleSave } = this.props;

        if (!userProfile.shouldShowNationalityField) return;

        return (
            <div className="md-form-group row">
                <div className="col-sm-6">
                    <SelectList
                        autofocus={this.props.focus.get('nationality')}
                        profileModel="userProfile.nationality"
                        name="country"
                        optionsList={this.props.nationalityCountries}
                        clearable={false}
                        autoCompleteField={false}
                        label={formatText('field-country')}
                        placeholder={formatText('field-country')}
                        validations={{
                            required: value => {
                                return value && value.length;
                            },
                        }}
                        messagesError={{ required: formatText('validation-nationalityRequired') }}
                        required
                        searchable={true}
                        disabled={disableNationalityByCountry(userProfile.documentType)}
                        isUpdated={function () {
                            const data = {};
                            data['nationality'] = userProfile.nationality;
                            handleSave(null, data);
                        }}
                        {...this.props}
                    />
                </div>
            </div>
        );
    };

    showBirthPopulationInput = () => {
        const { userProfile, handleSave, handleNextStep } = this.props;

        return (
            <div className="md-form-group row">
                <div className="col-sm-6">
                    <InputText
                        profileModel="userProfile.birthPopulation"
                        label={formatText('field-birthPoblation')}
                        placeholder={formatText('field-birthPoblation')}
                        type="text"
                        name="birthPopulation"
                        id="birthPopulation"
                        pasteDisabled={false}
                        autoCompleteField={false}
                        replaceFunction={normalizeStringsSpain}
                        validations={{
                            required: value => value && value.length,
                            valid: value => validator.matches(value, alphabetRegExpByCountry()),
                        }}
                        isValidated={function () {
                            handleNextStep(true);
                            handleSave('birthPopulation', userProfile.birthPopulation);
                        }}
                        isNotValidated={function () {
                            handleNextStep(false);
                        }}
                        messagesError={{
                            required: formatText('validation-fieldRequired'),
                            valid: formatText('validation-invalidBirthPoblation'),
                        }}
                        disabled={false}
                        {...this.props}
                    />
                </div>
            </div>
        );
    };

    showBirthProvinceInput = () => {
        const { userProfile, getProvinces, handleSave } = this.props;
        const provinces = getProvinces();

        if (userProfile.birthCountry === COUNTRY_CODE_ES) {
            return (
                <div className="md-form-group row">
                    <div className="col-sm-6">
                        <SelectList
                            profileModel="userProfile.birthProvince"
                            name="birthProvince"
                            clearable={false}
                            label={formatText('field-birthProvince')}
                            placeholder={formatText('field-birthProvince')}
                            optionsList={provinces}
                            value={userProfile.birthProvince}
                            validations={{
                                required: value => {
                                    return value && !tools.isEmptyOrWhitespace(value);
                                },
                            }}
                            autoCompleteField={false}
                            messagesError={{ required: formatText('validation-provinceRequired') }}
                            required
                            searchable={true}
                            disabled={false}
                            isUpdated={function () {
                                handleSave('birthProvince', userProfile.birthProvince);
                            }}
                            onChange={function (value) {
                                handleSave('birthProvince', value);
                            }}
                            {...this.props}
                        />
                    </div>
                </div>
            );
        }
    };

    getRowPostalCode(handleAddressUpdate, disabled) {
        if (mustShowExtraAddressFields()) {
            return (
                <GeoRowGroup>
                    <GeoInput
                        id="postalCode"
                        baseModelProperty="postalCode"
                        baseModelForm={this.props.userProfileForm}
                        gmapsType="postal_code"
                        value={this.props.userProfile.postalCode}
                        label={formatText('field-postalCode')}
                        size={4}
                        type={__ORIGIN_COUNTRY__ == COUNTRY_CODE_NL ? 'text' : 'tel'}
                        maxLength={getMaxLenghtPostalCode()}
                        placeholder={formatText('field-postalCode', [], true)}
                        validators={{
                            required: value => {
                                const isOk = !tools.isEmptyOrWhitespace(value);
                                if (!isOk) {
                                    this.handleErrorTags('postalcode', 'validation-fieldRequired');
                                }

                                return isOk;
                            },
                            valid: value => {
                                let isOk = false;
                                if (!tools.isEmptyOrWhitespace(value)) {
                                    // result = validator.isInt(value.toString(), { min: 0, allow_leading_zeroes: true });
                                    isOk = true;
                                }

                                if (!isOk) {
                                    this.handleErrorTags('postalcode', 'validation-syntaxErrorPostalCode');
                                }

                                return isOk;
                            },
                        }}
                        errorMessages={{
                            required: formatText('validation-fieldRequired'),
                            valid: formatText('validation-syntaxErrorPostalCode'),
                            zip: formatText('validation-postalCodeServer'),
                        }}
                        onUpdate={handleAddressUpdate}
                        disabled={disabled}
                    />
                    <GeoInput
                        id="town"
                        baseModelProperty="town"
                        baseModelForm={this.props.userProfileForm}
                        gmapsType="town"
                        value={this.props.userProfile.town}
                        label={formatText('field-town')}
                        size={4}
                        maxLength={40}
                        placeholder={formatText('field-town')}
                        validators={{
                            required: value => {
                                const isOk = !tools.isEmptyOrWhitespace(value);
                                if (!isOk) {
                                    this.handleErrorTags('town', 'validation-fieldRequired');
                                }

                                return isOk;
                            },
                            valid: value => {
                                const isOk =
                                    value !== ''
                                        ? !tools.isEmptyOrWhitespace(value) &&
                                          validator.matches(value.toString(), /^[a-zA-ZÀ-ÿ'-\s]+$/) &&
                                          value.length <= 40
                                        : true;
                                if (!isOk) {
                                    this.handleErrorTags('town', 'validation-syntaxError');
                                }

                                return isOk;
                            },
                        }}
                        errorMessages={{
                            required: formatText('validation-fieldRequired'),
                            valid: formatText('validation-syntaxError'),
                        }}
                        onUpdate={handleAddressUpdate}
                        disabled={disabled}
                    />
                    <GeoSelect
                        id="province"
                        baseModelProperty="province"
                        baseModelForm={this.props.userProfileForm}
                        gmapsType="administrative_area_level_2"
                        options={this.props.options.get('cities').toJS()}
                        value={this.props.userProfile.province}
                        label={formatText('field-province')}
                        size={4}
                        validators={{
                            required: value => !tools.isEmptyOrWhitespace(value),
                        }}
                        errorMessages={{
                            required: formatText('validation-fieldRequired'),
                            zip: formatText('validation-postalCodeServer'),
                        }}
                        onUpdate={handleAddressUpdate}
                        disabled={disabled}
                    />
                </GeoRowGroup>
            );
        }

        return (
            <GeoRowGroup>
                <GeoInput
                    id="postalCode"
                    baseModelProperty="postalCode"
                    baseModelForm={this.props.userProfileForm}
                    gmapsType="postal_code"
                    value={this.props.userProfile.postalCode}
                    label={formatText('field-postalCode')}
                    size={4}
                    type={__ORIGIN_COUNTRY__ == COUNTRY_CODE_NL ? 'text' : 'tel'}
                    maxLength={getMaxLenghtPostalCode()}
                    placeholder={formatText('field-postalCode', [], true)}
                    validators={{
                        required: value => {
                            const isOk = !tools.isEmptyOrWhitespace(value);
                            if (!isOk) {
                                this.handleErrorTags('postalcode', 'validation-fieldRequired');
                            }

                            return isOk;
                        },
                        valid: value => {
                            let isOk = false;
                            if (!tools.isEmptyOrWhitespace(value)) {
                                isOk = postalCode[__ORIGIN_COUNTRY__](value);
                            }
                            if (!isOk) {
                                this.handleErrorTags('postalcode', 'validation-syntaxErrorPostalCode');
                            }

                            return isOk;
                        },
                    }}
                    errorMessages={{
                        required: formatText('validation-fieldRequired'),
                        valid: formatText('validation-syntaxErrorPostalCode'),
                        zip: formatText('validation-postalCodeServer'),
                    }}
                    onUpdate={handleAddressUpdate}
                    disabled={disabled}
                    mask={getPostalCodeMaskCountry()}
                />
                <GeoInput
                    id="town"
                    baseModelForm={this.props.userProfileForm}
                    baseModelProperty="town"
                    gmapsType="town"
                    value={this.props.userProfile.town}
                    label={formatText('field-town')}
                    size={4}
                    maxLength={40}
                    placeholder={formatText('field-town')}
                    validators={{
                        required: value => {
                            const isOk = !tools.isEmptyOrWhitespace(value);
                            if (!isOk) {
                                this.handleErrorTags('town', 'validation-fieldRequired');
                            }

                            return isOk;
                        },
                        valid: value => {
                            const isOk =
                                value !== ''
                                    ? !tools.isEmptyOrWhitespace(value) &&
                                      validator.matches(value.toString(), /^[a-zA-ZÀ-ÿ'-\s]+$/) &&
                                      value.length <= 40
                                    : true;
                            if (!isOk) {
                                this.handleErrorTags('town', 'validation-syntaxError');
                            }

                            return isOk;
                        },
                    }}
                    errorMessages={{
                        required: formatText('validation-fieldRequired'),
                        valid: formatText('validation-syntaxError'),
                    }}
                    onUpdate={handleAddressUpdate}
                    disabled={disabled}
                />
            </GeoRowGroup>
        );
    }

    validateAddressNumber = value => {
        const { flags } = this.props;
        if (flags.get(STREET_LETTER)) {
            return validator.matches(value.toString(), /^S\/N$|^s\/n$|^[a-zA-Z0-9,-. ]*$/);
        }

        return validator.matches(value.toString(), /^S\/N$|^s\/n$|^[0-9,-. ]*$/);
    };

    addTypeOfRoadText = () => {
        const {
            userProfile: { typeOfRoad, address },
            roads,
        } = this.props;
        const roadData = getRoadDataByTypeOfRoad(roads, typeOfRoad);

        if (!roadData) {
            return '';
        }

        const isAddressWithTypeRoad = address && address.includes(roadData.name);

        return isAddressWithTypeRoad ? '' : roadData.name;
    };

    countryPhone = () => {
        return this.props.userProfile.cellphonePrefix === COUNTRY_PREFIX_UA ? COUNTRY_CODE_UA : __ORIGIN_COUNTRY__;
    };

    generateAddressData = () => {
        const {
            options,
            userProfile: { typeOfRoad, nameOfRoad, addressNumber, town, country, postalCode, additionalInfo },
        } = this.props;

        const roadTypes = options.get('typesOfRoads');
        const roadTypeData = getRoadDataByTypeOfRoad(roadTypes, typeOfRoad);

        return {
            adviseAddress: `${roadTypeData ? `${roadTypeData.name} ` : ''}${nameOfRoad} ${addressNumber}`,
            postalCodeAndTown: `${postalCode} ${town} ${isCountrySpain() ? country : ''}`,
            additionalInfo,
        };
    };

    handleOnClickAdExtraData = () => {
        this.setState({ warningAdditionalInfo: true });
        this.extraDataRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    handleOnClickEdit = () => {
        const isElementVisible = this.addressRef.current.offsetParent;
        isElementVisible
            ? this.addressRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
            : this.nameOfRoadRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    render() {
        const {
            userProfile,
            formActions,
            immStepsState,
            showOpenCredit,
            flags,
            showJointHolderDecision,
            showAdditionalDataAdvise,
        } = this.props;

        const { warningAdditionalInfo } = this.state;

        const disabled = immStepsState.get('readOnlyForms');
        const handleSave = this.props.handleSave;
        const handleNextStep = this.props.handleNextStep;
        const handleAddressUpdate = this.props.handleAddressUpdate;
        const handlePhoneOnFocus = this.handlePhoneOnFocus;
        const classnames = className({ 'joint-holder__margin': userProfile.isJointHolder });

        const { address } = this.props.userProfile || '';
        const userAddress = address && `${this.addTypeOfRoadText()} ${address}`;
        const { adviseAddress, postalCodeAndTown, additionalInfo } = this.generateAddressData();
        const showWarningAdditionalInfo = warningAdditionalInfo && !additionalInfo;

        return (
            <div className="profile-step-1 prospects-gutter prospects-separator">
                <input id="disable-autocomplete-input-dummy-phone" style={{ display: 'none' }} type="text" />
                <div className="row">
                    <div className="col-sm-6">
                        <div className="md-form-group">
                            <InputText
                                areaCode={true}
                                prefixSelection={true}
                                handleSave={handleSave}
                                profileModel="userProfile.cellPhone"
                                label={formatText('field-cellPhone')}
                                placeholder={formatText('field-cellPhonePlaceHolder')}
                                maxLength={11}
                                onKeyDown={e => {
                                    const numberRegex = /^[0-9]$/;
                                    if (!numberRegex.test(e.key) && e.key.length === 1) {
                                        e.preventDefault();
                                    }
                                }}
                                type="tel"
                                name="cellPhone"
                                id="cellPhone"
                                defaultValue={userProfile.cellPhone}
                                validations={{
                                    required: value => {
                                        const isRequired = value && value.length;
                                        if (!isRequired) {
                                            const cellPhoneConfirmation =
                                                document.getElementById('cellPhoneConfirmation');
                                            formActions.change('userProfile.cellPhoneConfirmation', '');
                                            cellPhoneConfirmation.value = '';
                                        }

                                        return isRequired;
                                    },
                                    valid: value => {
                                        const valueStandar = value.replace(/\s/g, '');
                                        const valueConfirmation = userProfile.cellPhoneConfirmation
                                            ? userProfile.cellPhoneConfirmation.replace(/\s/g, '')
                                            : '';
                                        const isValidStandar = validateCellPhone(valueStandar, this.countryPhone());
                                        const isValidValueConfirmation = validateCellPhone(
                                            valueConfirmation,
                                            this.countryPhone()
                                        );
                                        if (!isValidStandar) {
                                            formActions.setValidity('userProfile.cellPhoneConfirmation', {
                                                valid: isValidValueConfirmation && valueStandar === valueConfirmation,
                                            });

                                            return false;
                                        }
                                        if (valueConfirmation === '') {
                                            const cellPhoneConfirmation =
                                                document.getElementById('cellPhoneConfirmation');
                                            cellPhoneConfirmation.focus();

                                            return true;
                                        }
                                        formActions.setValidity('userProfile.cellPhoneConfirmation', {
                                            valid: valueConfirmation === valueStandar,
                                        });

                                        return true;
                                    },
                                }}
                                onFocus={function () {
                                    handlePhoneOnFocus('cellPhone');
                                }}
                                onBlur={this.handlePhoneOnBlur}
                                isValidated={function () {
                                    handleNextStep(true);
                                }}
                                isNotValidated={function () {
                                    handleNextStep(false);
                                }}
                                messagesError={{
                                    required: formatText('validation-fieldRequired'),
                                    valid: formatText('validation-cellPhone'),
                                }}
                                autoCompleteField={false}
                                disabled={disabled || userProfile?.cellPhoneDisabled}
                                {...this.props}
                            />
                        </div>
                        <div className="md-form-group">
                            <InputText
                                prefixSelection={true}
                                handleSave={handleSave}
                                areaCode={true}
                                profileModel="userProfile.cellPhoneConfirmation"
                                label={formatText('field-cellPhoneConfirmation')}
                                placeholder={formatText('field-cellPhonePlaceHolder')}
                                type="tel"
                                maxLength={11}
                                onKeyDown={e => {
                                    const numberRegex = /^[0-9]$/;
                                    if (!numberRegex.test(e.key) && e.key.length === 1) {
                                        e.preventDefault();
                                    }
                                }}
                                name="cellPhoneConfirmation"
                                id="cellPhoneConfirmation"
                                defaultValue={userProfile.cellPhoneConfirmation}
                                pasteDisabled={true}
                                autoCompleteField={false}
                                validations={{
                                    required: value => value && value.length,
                                    valid: value => {
                                        const valueConfirmation = value.replace(/\s/g, '');
                                        const valueStandar = userProfile.cellPhone
                                            ? userProfile.cellPhone.replace(/\s/g, '')
                                            : '';
                                        const isValidConfirmation = validateCellPhone(
                                            valueConfirmation,
                                            this.countryPhone()
                                        );
                                        const isValidValueStandar = validateCellPhone(
                                            valueStandar,
                                            this.countryPhone()
                                        );
                                        if (!isValidConfirmation || valueConfirmation !== valueStandar) {
                                            formActions.setValidity('userProfile.cellPhone', {
                                                valid: isValidValueStandar,
                                            });

                                            return false;
                                        }
                                        formActions.setValidity('userProfile.cellPhone', { valid: true });

                                        return true;
                                    },
                                }}
                                onFocus={function () {
                                    handlePhoneOnFocus('cellPhoneConfirmation');
                                }}
                                onBlur={this.handlePhoneOnBlur}
                                isValidated={function () {
                                    handleNextStep(true);
                                    const newInputPhoneValue = userProfile.cellPhone.replace(/\s/g, '');
                                    handleSave('cellPhone', newInputPhoneValue);
                                }}
                                isNotValidated={function () {
                                    handleNextStep(false);
                                }}
                                messagesError={{
                                    required: formatText('validation-fieldRequired'),
                                    valid: value => {
                                        let message;
                                        if (
                                            !validateCellPhone(userProfile.cellPhoneConfirmation, this.countryPhone())
                                        ) {
                                            message = formatText('validation-cellPhone');
                                        } else if (value !== userProfile.cellPhone) {
                                            message = formatText('validation-confirmCellPhone');
                                        }

                                        return message;
                                    },
                                }}
                                disabled={disabled || userProfile?.cellPhoneDisabled}
                                {...this.props}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="phone-info">
                            <div className="iconContainer">
                                <i className="icons icons--icon-phone"></i>
                            </div>
                            <div className="text-container">
                                <h3 className="font-heading3">
                                    {formatText('contentStepsTitles-SpanishMobileNumber')}
                                </h3>
                                <p className="font-paragraph2">
                                    {formatText('contentStepsDescriptions-spanishMobileDescription')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="address-titles-container">
                    <h5 className="address-title">{<FormattedText value="field-addressTitle" />}</h5>
                    <p className="address-subtitle">{<FormattedText value="field-addressSubtitle" />}</p>
                </div>
                <div>
                    <GeoAddress
                        refProp={this.addressRef}
                        label={this.getLabelAddress(flags)}
                        baseModelDescriptor="userProfile"
                        baseModelProperty="address"
                        baseModelForm={this.props.userProfileForm}
                        onUpdate={handleAddressUpdate}
                        value={userAddress}
                        disabled={disabled}
                        id="addressAutocomplete"
                        isFilled={this.isFilledAddress}
                        language={getLanguage()}
                        hiddenSearch={!flags.get(MAPS_SEARCH)}
                        showChildren={true}
                    >
                        {this.getRowTypeOfRoad(handleAddressUpdate, disabled)}
                        <GeoRowGroup>
                            <GeoInput
                                id="addressNumber"
                                baseModelProperty="addressNumber"
                                baseModelForm={this.props.userProfileForm}
                                gmapsType="street_number"
                                value={this.props.userProfile.addressNumber}
                                label={formatText('field-number')}
                                mask={'c'.repeat(getLengthAddressNumber())}
                                formatChars={{
                                    c: '[A-Za-z0-9/]',
                                }}
                                size={4}
                                type="text"
                                placeholder={formatText('field-number')}
                                validators={{
                                    required: value => {
                                        const isOk = !tools.isEmptyOrWhitespace(value);
                                        if (!isOk) {
                                            this.handleErrorTags('streetnumber', 'validation-numberRequired');
                                        }

                                        return isOk;
                                    },
                                    valid: value => {
                                        const isOk = this.validateAddressNumber(value);
                                        if (!isOk) {
                                            this.handleErrorTags('streetnumber', 'validation-numberNoValid');
                                        }

                                        return isOk;
                                    },
                                    length: value => {
                                        const isOk = value.length <= getLengthAddressNumber();
                                        if (!isOk) {
                                            this.handleErrorTags('streetnumber', 'validation-numberLength');
                                        }

                                        return isOk;
                                    },
                                }}
                                errorMessages={{
                                    required: formatText('validation-numberRequired'),
                                    valid: formatText('validation-numberNoValid'),
                                    length: formatText('validation-numberLength'),
                                }}
                                onUpdate={handleAddressUpdate}
                                disabled={disabled}
                            />

                            <GeoInput
                                refProp={this.extraDataRef}
                                id="additionalInfo"
                                baseModelProperty="additionalInfo"
                                baseModelForm={this.props.userProfileForm}
                                gmapsType="additional_info"
                                className={showWarningAdditionalInfo && 'warning-input'}
                                value={this.props.userProfile.additionalInfo}
                                label={formatText('field-additionalInfoLabel')}
                                subText={formatText('field-additionalInfoDescription')}
                                size={8}
                                maxLength={getLengthAdditionalInfo()}
                                placeholder={formatText('field-additionalInfo')}
                                validators={{
                                    valid: value => {
                                        //FIXME: ^[A-Z0-9À-ÿ_./\\?,:;-\s\u005B\u005D\u003C\u003E\u00B0\u00AA\u00BA]*$
                                        return (
                                            (!tools.isEmptyOrWhitespace(value) &&
                                                validator.matches(
                                                    value.toString(),
                                                    noOrdinaryCharactersRegExpWithDotAndComma
                                                ) &&
                                                value.length <= 33) ||
                                            tools.isEmptyOrWhitespace(value)
                                        );
                                    },
                                }}
                                errorMessages={{
                                    valid: formatText('validation-syntaxError'),
                                }}
                                onUpdate={handleAddressUpdate}
                                disabled={disabled}
                            />
                        </GeoRowGroup>
                        {this.getRowPostalCode(handleAddressUpdate, disabled)}
                        <GeoInput
                            id="country"
                            baseModelProperty="country"
                            baseModelForm={this.props.userProfileForm}
                            gmapsType="country"
                            value={this.props.userProfile.country}
                            size={0}
                            onUpdate={handleAddressUpdate}
                            disabled={disabled}
                        />
                    </GeoAddress>
                </div>
                <div className="md-form-group form__input">
                    <label className="_radio-label">{formatText('field-gender')}</label>
                    <RadioButton
                        profileModel="userProfile.gender"
                        optionsList={[
                            {
                                label: formatText('field-woman'),
                                value: 'female',
                            },
                            {
                                label: formatText('field-man'),
                                value: 'male',
                            },
                        ]}
                        isRequired
                        isUpdated={function () {
                            handleSave('gender', userProfile.gender);
                            recordEvent(
                                undefined,
                                undefined,
                                undefined,
                                undefined,
                                undefined,
                                undefined,
                                undefined,
                                undefined,
                                undefined,
                                {
                                    categoriaEvento: 'eventos onboarding',
                                    accionEvento: 'sexo',
                                    etiquetaEvento: userProfile.gender,
                                }
                            );
                        }}
                        disabled={disabled}
                        messagesError={{ required: formatText('validation-radioRequired') }}
                        style={{ margin: '0 0 -9px' }}
                        {...this.props}
                    />
                </div>
                {this.showBirthCountryInput()}
                {this.showBirthProvinceInput()}
                {this.showBirthPopulationInput()}
                {this.showNationalityInput()}
                <div className={classnames}>{showOpenCredit}</div>

                {userProfile?.universiaName ? (
                    <AlertWarning title="initial-reuseAddDataTitle" description="initial-reuseAddDataText" />
                ) : (
                    showJointHolderDecision
                )}
                {showAdditionalDataAdvise && (
                    <AdditionalDataAdvise
                        address={adviseAddress}
                        additionalInfo={additionalInfo}
                        postalCodeAndTown={postalCodeAndTown}
                        onClickAdExtraData={this.handleOnClickAdExtraData}
                        onClickEdit={this.handleOnClickEdit}
                    />
                )}
            </div>
        );
    }
}

ProfileStep1Form.propTypes = {
    handleSave: PropTypes.func,
    handleNextStep: PropTypes.func,
    showJointHolderDecision: PropTypes.any,
    birthCountries: PropTypes.array,
    nationalityCountries: PropTypes.array,
    handleAddressUpdate: PropTypes.func,
    showOpenCredit: PropTypes.any,
    getProvinces: PropTypes.any,
    userProfile: PropTypes.object,
    userProfileForm: PropTypes.object,
    immStepsState: PropTypes.object,
    roads: PropTypes.object,
    options: PropTypes.object,
    focus: PropTypes.object,
    formActions: PropTypes.object,
    flags: PropTypes.any,
};

module.exports.constructor = ProfileStep1Form;
module.exports.ProfileStep1Form = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        roads: state.options.get('typesOfRoads'),
        options: state.options,
        focus: state.focus,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
    })
)(withFeatureToggling(ProfileStep1Form));
